import {ErrorProcessor} from "@dv5/api"
import {clearErrorMessage, setErrorMessage, setProgressStep} from "@dv5/domain"
import {Dispatch} from "react"

export const RECONNECT_ERROR = 'Wrong session id'

export class ErrorDisplayProcessor implements ErrorProcessor {

    private dispatch: Dispatch<any>

    constructor(dispatch: Dispatch<any>) {
        this.dispatch = dispatch
    }

    displayError(message: string): void {
        this.dispatch(setErrorMessage(message))
        const delay = (message === RECONNECT_ERROR) ? 2000 : 8000

        const timeoutId = setTimeout(() => {
            this.dispatch(clearErrorMessage())
            clearTimeout(timeoutId)
        }, delay)
    }

    displayStep(step: number): void {
        this.dispatch(setProgressStep(step))
        if (step >= 2) {
            const timeoutId = setTimeout(() => {
                this.dispatch(setProgressStep(0))
                clearTimeout(timeoutId)
            }, 500)
        }
    }

}
